import React from 'react';
import * as ReduxToolkit from '@reduxjs/toolkit';
import * as Redux from 'react-redux';
import makeStyles from '@material-ui/core/styles/makeStyles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { Alert, AlertTitle } from '@material-ui/lab';
import Typography from '@material-ui/core/Typography';
import { Button } from '@material-ui/core';
import { warnMobile } from 'components/app/app-redux';
import { RootState } from '../../../../global';

const useStyles = makeStyles(() => ({
  root: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: '100vw',
    height: '100%',
    zIndex: 1000,
    overflow: 'hidden',
    padding: '8px',
  },
  action: {
    position: 'absolute',
    top: '8px',
    right: '32px',
    zIndex: 10000,
  },
  continue: {
    marginTop: '16px',
  },
}));

export function MobileWarn() {
  const isMobile = useMediaQuery('(max-width:600px)');
  const classes = useStyles();

  const dispatch = Redux.useDispatch();
  const hasWarnedMobileSelector = ReduxToolkit.createSelector(
    (state: RootState) => state.configuration.hasWarnedMobile,
    (res) => res,
  );
  const hasWarnedMobile = Redux.useSelector(hasWarnedMobileSelector);

  if (hasWarnedMobile || !isMobile) {
    return null;
  }

  return (
    <Alert
      severity="info"
      onClose={() => {
        dispatch(warnMobile());
      }}
      className={classes.root}
      classes={{
        action: classes.action,
      }}
    >
      <AlertTitle>Surfar du på mobilen?</AlertTitle>
      <Typography>
        Det verkar som att ni använder en mobil eller liten skärm.
        Beställningsformuläret syns bäst på en större skärm såsom dator eller
        surfplatta.
      </Typography>
      <Button
        disableElevation
        color="inherit"
        className={classes.continue}
        variant="contained"
        onClick={() => {
          dispatch(warnMobile());
        }}
      >
        Fortsätt ändå…
      </Button>
    </Alert>
  );
}
